// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp from 'tenants/_template/desktop/search'

  

  
  export default PageOrApp;